import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Box, Paper } from '@mui/material';
import { formateoFechasParaCaratulas } from 'utils/utilities';
import { NavLink } from 'react-router-dom';
import { theme } from 'theme/theme';
import './CardTaller.scss';

interface CardProps {
  img?: string;
  titulo: string;
  fechaIni?: Date;
  fechaFin?: Date;
  textoBoton: string;
  id: number;
  mostrarFechas: boolean;
  path: string;
}

const CardTaller = ({ img, titulo, path, fechaIni, fechaFin, mostrarFechas, textoBoton, id }: CardProps) => {
  const rangoFechas = fechaIni && fechaFin ? formateoFechasParaCaratulas(fechaIni, fechaFin) : 'Sin próximas funciones';

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
        width: '340px',
      }}
    >
      <Card
        className="cardTalleres"
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <CardContent sx={{ p: 0, height: '340px' }} className="cardContent">
          <CardMedia
            sx={{ height: '340px', display: 'flex', flexDirection: 'column', justifyContent: 'end' }}
            image={img}
          >
            <Box
              sx={{ backgroundColor: 'rgba(20, 20, 20, 0.7)', minHeight: '140px' }}
              display="flex"
              flexDirection="column"
              justifyContent={'center'}
            >
              <Typography
                gutterBottom={mostrarFechas ? true : false}
                variant="h5"
                component="div"
                color={theme.palette.primary.contrastText}
              >
                {titulo}
              </Typography>
              {mostrarFechas && (
                <Typography variant="body1" color={theme.palette.primary.contrastText}>
                  {rangoFechas}
                </Typography>
              )}
              <CardActions sx={{ justifyContent: 'center' }}>
                <NavLink to={`/${path}/${id}`}>
                  <Button size="small" sx={{ color: theme.palette.secondary.main }}>
                    {textoBoton}
                  </Button>
                </NavLink>
              </CardActions>
            </Box>
          </CardMedia>
        </CardContent>
      </Card>
    </Paper>
  );
};

export default CardTaller;
